import { green } from "@material-ui/core/colors";
import { whiteColor, container, cardTitle } from "../../lib/style";

const loginPageStyle = (theme) => ({
  container: {
    ...container,
    zIndex: "4",
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  textCenter: {
    textAlign: "center",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
    marginTop: "10px",
    maxHeight: "140px",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  footer: {
    justifyContent: "center !important",
    flexDirection: "column",
  },
  buttonWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});

export default loginPageStyle;
